"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    background: _styles.colors.white,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px',
    zIndex: 5,
    transition: 'opacity 0.3s',
    position: 'fixed',
    top: function top(_ref) {
      var verticalAlignment = _ref.verticalAlignment;
      if (verticalAlignment === 'start') return '40px';
      if (verticalAlignment === 'center') return '50%';
      return '';
    },
    bottom: function bottom(_ref2) {
      var verticalAlignment = _ref2.verticalAlignment;
      return verticalAlignment === 'end' ? '40px' : '';
    },
    left: function left(_ref3) {
      var horizontalAlignment = _ref3.horizontalAlignment;
      if (horizontalAlignment === 'start') return '40px';
      if (horizontalAlignment === 'center') return '50%';
      return '';
    },
    right: function right(_ref4) {
      var horizontalAlignment = _ref4.horizontalAlignment;
      return horizontalAlignment === 'end' ? '40px' : '';
    },
    transform: function transform(_ref5) {
      var verticalAlignment = _ref5.verticalAlignment,
          horizontalAlignment = _ref5.horizontalAlignment;
      if (verticalAlignment === 'center') return 'translateY(-50%)';
      if (horizontalAlignment === 'center') return 'translateX(-50%)';
      return '';
    }
  },
  hidden: {
    opacity: 0
  },
  content: {
    padding: '5px 15px'
  },
  closeIcon: {
    height: '10px',
    width: '10px',
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer'
  }
};
var _default = styles;
exports["default"] = _default;